<template>
	<div class="review-statistic">
		<PageHeader>
			<StatisticsLinkList />
		</PageHeader>
		<SelectListTab
			v-model="selectedTab"
			:tabList="tabList"
			class="review-statistic__tab"
		/>
		<section class="review-statistic__content">
			<DailyReviewStatistics v-if="selectedTab === '데일리 리뷰통계'" />
			<DateRagneStatistics v-if="selectedTab === '기간 별 리뷰수'" />
			<TopCategoryStatistics
				v-if="selectedTab === 'TOP Category by Review'"
			/>
			<TopBrandStatistic v-if="selectedTab === 'TOP Brand by Review'" />
			<TopProductStatistics
				v-if="selectedTab === 'TOP Product by Review'"
			/>
		</section>
	</div>
</template>
<script>
	import PageHeader from '@/components/PageHeader';
	import StatisticsLinkList from '@/components/operation/StatisticsLinkList';
	import SelectListTab from '@/components/common/SelectListTab';
	import DailyReviewStatistics from '@/components/operation/ReviewStatistic/DailyReviewStatistics';
	import DateRagneStatistics from '@/components/operation/ReviewStatistic/DateRagneStatistics';
	import TopBrandStatistic from '@/components/operation/ReviewStatistic/TopBrandStatistic';
	import TopCategoryStatistics from '@/components/operation/ReviewStatistic/TopCategoryStatistics';
	import TopProductStatistics from '@/components/operation/ReviewStatistic/TopProductStatistics';

	export default {
		name: 'ReviewStatistics',
		components: {
			PageHeader,
			StatisticsLinkList,
			SelectListTab,
			DailyReviewStatistics,
			DateRagneStatistics,
			TopBrandStatistic,
			TopCategoryStatistics,
			TopProductStatistics,
		},
		data() {
			return {
				tabList: [
					'데일리 리뷰통계',
					'기간 별 리뷰수',
					'TOP Category by Review',
					'TOP Brand by Review',
					'TOP Product by Review',
				],
				selectedTab: '데일리 리뷰통계',
			};
		},
	};
</script>
<style lang="scss" scoped></style>
